function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */ import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import ContourLogo from 'svg/mobileReports/Contour-logo.svg';
import App from 'modules/App';
import { formatDate } from 'helpers/datetime';
import intlShape from 'shapes/intlShape';
import messages from 'modules/PatientResults/messages';
import styles from './Header.pcss';
import Legend from './Legend';
var _React_Component;
class Header extends (_React_Component = React.Component) {
    render() {
        const { accountPatientProfile, phiSet, localizationResources } = this.props;
        if (!accountPatientProfile || !phiSet) return null;
        const profile = `${accountPatientProfile.firstName} ${accountPatientProfile.lastName}`;
        const diabetesType = App.messages.diabetesTypes[phiSet.diabetesType] ? `${this.props.intl.formatMessage(App.messages.diabetesTypes[phiSet.diabetesType])}` : '-';
        const treatmentType = App.messages.treatmentTypes[phiSet.treatmentType] ? get(localizationResources, `treatmentType_${toLower(phiSet.treatmentType)}.value`, phiSet.treatmentType) : '-';
        const dateOfBirth = `${this.props.intl.formatMessage(messages.glucoseReport.dateOfBirth)}: 
              ${accountPatientProfile.dateOfBirth ? formatDate(accountPatientProfile.dateOfBirth) : '-'}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.headerDailyLogReport,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerDailyLogReport__info,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: profile
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: `${diabetesType} , ${treatmentType}`
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: dateOfBirth
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: accountPatientProfile.email
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerDailyLogReport__title,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(ContourLogo, {
                                className: styles.headerDailyLogReport__logo
                            })
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.title))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Legend, {})
                })
            ]
        });
    }
}
_define_property(Header, "propTypes", {
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit props
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    conversion: PropTypes.object.isRequired,
    localizationResources: PropTypes.object
});
const mapStateToProps = (state)=>({
        localizationResources: App.selectors.localizationResources(state)
    });
const ConnectedHeader = connect(mapStateToProps)(injectIntl(Header));
export default withStyles(styles)(injectIntl(ConnectedHeader));
